export const colorCodeList = [
     '#001f3f',
     '#DAEDFF'
];

/**
 * Charts Color Codes
 */
export const chartColorCodes = [
     // '#02B2AF',
     // '#B800D8',
     // '#2E96FF',
     // '#60009B',
     // '#28a745',
     // '#dc3545',
     // '#6f42c1',
     // '#fd7e14',
     // '#20c997',
     // '#e83e8c',
     // '#ffc107',
     // '#6610f2',
     // '#17a2b8'

     '#37bd79',
     '#a7e237',
     '#1ebbd7',
     '#a73c5a',
     '#ff7954',
     '#549aab',
     '#a7adb2',
     '#E6B0AA',
     '#D7BDE2',
     '#A9CCE3',
     '#AED6F1',
     '#A2D9CE',
     '#F9E79F',
     '#BCAAA4',
     '#F8BBD0'
];

export const itemHoverColor = '#DAEDFF';

export const headingColor2 = '#778899';

export const homeBackground = '#f0f0f0';

export const errorColor = '#D32F2F';
export const successColor = '#009900';

export const colorPalette = {
     C1: '#001f3f'
}

export const homeColor = {
     // primary: '#900C3F',
     // primary1: '#C70039',
     // secondary: '#FF5733',
     // secondary1: '#FFC300',
     // background: '#DAF7A6',
     // hover: '#FFD2C9',
     // subtext: '#525252',
     // footerlink: '#CCCABD',
     footerlink: '#F5F5F5',
     footerIcon: '#292929',

     primary: '#900C3F',
     primary1: '#C70039',
     primary2: '#B10035',
     primary3: '#95012E',

     secondary: '#FF5733',
     secondary1: '#FF9D8A',
     secondary2: '#FF785E',
     secondary3: '#FF3F0D',

     background: '#DAF7A6',
     background1: '#B9F17D',
     background2: '#94E54F',
     background3: '#6FD221',

     hover: '#FFD2C9',
     hover1: '#FFA19E',
     hover2: '#FF8277',
     hover3: '#FF5641',

     subtext: '#525252',
     subtext1: '#777777',
     subtext2: '#909090',
     subtext3: '#AAAAAA',

     divider: 'D9D9D9'
}